var map = {
	"./de.json": "796d",
	"./el.json": "a333",
	"./en.json": "dca7",
	"./es.json": "e60b",
	"./fi.json": "0542",
	"./fr.json": "596a",
	"./it.json": "baa9",
	"./ja.json": "5dc8",
	"./no.json": "631e",
	"./pt.json": "915f",
	"./ru.json": "5d8f",
	"./sv.json": "5ee2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81d4";